import { AutogenModelDrsManTimecard, AutogenRowDrsManTimecard } from "./autogen/AutogenModelDrsManTimecard";

export class ModelDrsManTimecard extends AutogenModelDrsManTimecard<RowDrsManTimecard> {
	constructor() {
		super(RowDrsManTimecard);
	}
}

export class RowDrsManTimecard extends AutogenRowDrsManTimecard {
}